import { SurveyTemplateDto } from '@families-link/shared';
import { createSlice } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../store';
import surveysApi from '../../../store/api/survey.api';

export type SurveyTemplateState = { currentSurveyTemplate: SurveyTemplateDto | null };

export const initialState = {
	currentSurveyTemplate: null,
};

export const surveyTemplateSlice = createSlice({
	name: 'surveyTemplate',
	initialState,
	reducers: {
		clearCurrentSurveyTemplate: (state: SurveyTemplateState) => {
			state.currentSurveyTemplate = null;
		},
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			surveysApi.endpoints.getSurveyTemplateById.matchFulfilled,
			(state: SurveyTemplateState, action) => {
				state.currentSurveyTemplate = action.payload;
			}
		);
	},
});

export const { clearCurrentSurveyTemplate } = surveyTemplateSlice.actions;

export const useCurrentSurveyTemplateSelector = () =>
	useAppSelector((state) => state.surveyTemplate.currentSurveyTemplate);
